////
/// ============================================================================
/// COMPONENT / Carousel
/// ============================================================================
///
/// @group components
////

import Swiper from 'swiper';

import SwiperCore, {Pagination, Navigation} from 'swiper';

SwiperCore.use([Pagination, Navigation]);

export default () => {
    const swiper = new Swiper('.js-product-carousel', {
        slidesPerView: 1,
        spaceBetween: '3%',
        slideClass: 'product',
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            dynamicBullets: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            700: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            1100: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
        },
    });
};



